import { useEffect, useState, useRef } from "react";
import httpClient from "../../_util/api";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
} from "@mui/material";
import FileUpload from "../../components/FileUpload";
import { UploadImagetoFb } from '../../Hooks/uploadImage';
import ButtonMain from "../../components/Button";
import { hideLoader, showLoader } from "../../Store/mainSlice";
import CustomizedSnackbars from "../../shared/Snackbar/SnackBar";
import { useDispatch } from 'react-redux';

const VendorPayments = () => {
  const challanPhotoRef = useRef();
  const dispatch = useDispatch();
  const snackbar_Ref = useRef();
  const [remarks, setRemarks] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedVendorId, setSelectedVendorId] = useState(null);  
  const [isReimbursementModal, setIsReimbursementModal] = useState(false);
  const [vendorList, setVendorList] = useState([]);
  const [amount, setAmount] = useState("");
  const [challanPhoto, setchallanPhoto] = useState({
    fileName: "",
    url: ""
  });

  const formatWithCommas = (value) => {
    const num = value.replace(/,/g, "");
    if (!num) return "";
    return parseFloat(num).toLocaleString("en-US");
  };

  const getVendorListHandler = async () => {
    try {
      const res = await httpClient.get(`/user/vendors`);
      if (res.status === 200) {
        setVendorList(res.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const uploadPhotoHandler = (ref) => {
    ref?.current?.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    dispatch(showLoader());
    try {
      const uploadedFile = await UploadImagetoFb(event);
      const newFile = {
        fileName: file.name,
        url: uploadedFile.url,
      };
      setchallanPhoto(newFile);
    } catch (err) {
      console.error("Upload error:", err);
      alert("File upload failed. Please try again.");
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleSubmitAction = async () => {
    dispatch(showLoader());
    const paymentData = {
      vendorId: selectedVendorId,
      amount: Number(amount),
      remarks,
      voucher: challanPhoto,
    };

    try {
      const paymentRes = await httpClient.post('/vendor-payment/', paymentData);
      if (paymentRes?.status === 200) {
        setVendorList(prevList =>
          prevList.map(vendor =>
            vendor._id === selectedVendorId
              ? {
                  ...vendor,
                  payments: {
                    ...vendor.payments,
                    balance: (vendor.payments?.balance || 0) + Number(amount),
                  },
                }
              : vendor
          )
        );

        if (isReimbursementModal) {
          try {
            await httpClient.post('/vendor-payment/udapte-reimbursement', { vendorId: selectedVendorId });
          } catch (err) {
            console.error("Reimbursement update failed", err);
          }
        }

        snackbar_Ref.current.showMessage("success", paymentRes.data?.message || "Payment successful", "", "i-chk-circle");
        setIsReimbursementModal(false);
        setIsModalOpen(false);
        resetForm();
      } else {
        snackbar_Ref.current.showMessage("error", paymentRes?.data?.message || "Unexpected error occurred", "", "i-chk-circle");
      }
    } catch (error) {
      snackbar_Ref.current.showMessage("error", error?.response?.data?.message || error?.message || "Server error", "", "i-chk-circle");
    } finally {
      dispatch(hideLoader());
    }
  };

  const resetForm = () => {
    setAmount("");
    setRemarks("");
    setchallanPhoto({ fileName: "", url: "" });
    setSelectedVendorId(null);
  };

  useEffect(() => {
    getVendorListHandler();
  }, []);

  return (
    <Paper sx={{ width: "100%", overflow: "hidden", padding: 2 }}>
      <CustomizedSnackbars ref={snackbar_Ref} />

      <Dialog open={isModalOpen} onClose={() => setIsModalOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>{isReimbursementModal ? "Add Vendor Reimbursement" : "Add Vendor Payment" }</DialogTitle>
        <DialogContent>
          <TextField
            label="Amount"
            type="text"
            fullWidth
            margin="normal"
            value={formatWithCommas(amount)}
            onChange={(e) => {
              const raw = e.target.value.replace(/,/g, "").replace(/[^\d]/g, "");
              setAmount(raw);
            }}
          />
          <FileUpload
            ref={challanPhotoRef}
            label="Upload Paid Challan"
            file={challanPhoto}
            onChange={handleFileChange}
            onClick={() => uploadPhotoHandler(challanPhotoRef)}
            onRemove={() =>
              setchallanPhoto({
                fileName: "",
                url: "",
              })
            }
          />
          <TextField
            label="Remarks"
            multiline
            rows={4}
            fullWidth
            margin="normal"
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <ButtonMain
            variant="white"
            onClick={() => {
              setIsModalOpen(false);
              resetForm();
            }}
          >
            Cancel
          </ButtonMain>
          <ButtonMain onClick={handleSubmitAction}>Submit</ButtonMain>
        </DialogActions>
      </Dialog>

      <TableContainer>
        <Table>
          <TableHead sx={{ backgroundColor: "#4caf50" }}>
            <TableRow>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>#</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Name</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Email</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Total Credit</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Total Debit</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Balance</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Total Reimbursement</TableCell>
              <TableCell sx={{ color: "white", fontWeight: "bold" }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {vendorList.map((item, index) => (
              <TableRow key={index} sx={{ cursor: "pointer" }}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{item.firstName}</TableCell>
                <TableCell>{item.email}</TableCell>
                <TableCell>{item.payments?.totalCredit ?? 0}</TableCell>
                <TableCell>{item.payments?.totalDebit ?? 0}</TableCell>
                <TableCell>{item.payments?.balance ?? 0}</TableCell>
                <TableCell>{item.payments?.totalReimbursement ?? 0}</TableCell>
                <TableCell>
                  <Box sx={{ display: "flex", gap: "8px"}}>
                    <ButtonMain
                      onClick={() => {
                        resetForm();
                        setSelectedVendorId(item._id);
                        setIsModalOpen(true);
                      }}
                    >
                      Add Payment
                    </ButtonMain>
                    <ButtonMain
                      variant="white"
                      onClick={() => {
                        resetForm();
                        setSelectedVendorId(item._id);
                        setIsModalOpen(true);
                        setIsReimbursementModal(true);
                      }}
                    >
                      Paid Reimbursement
                    </ButtonMain>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default VendorPayments;
